import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/button/button';
import { convertTo12HourFormat } from '../../../helpers/date-time-helpers';
import type { JDCState } from '../jdc/jdc.type';
import { bloomfilterStatusOptions } from './views.data';
import styles from './views.module.css';

type Props = {
  state: JDCState;
  setActiveStep: (activeStep: number) => void;
};

export function SummaryView({ state, setActiveStep }: Props) {
  const i18n = useTranslation();
  return (
    <div id={styles.viewContainer}>
      <h3>Review your Selections: </h3>
      <div id={styles.summaryContainer}>
        <div className={styles.summaryItem}>
          <div className={styles.flexRowSpaceBetween}>
            <h4 className={styles.summaryLabel}>Project:</h4>
            <Button variant="subtle" onClick={() => setActiveStep(0)}>
              <span className={styles.editButtonText}>Edit</span>
            </Button>
          </div>
          <span className={styles.summaryValue}>{state.project?.name || ''}</span>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.flexRowSpaceBetween}>
            <h4 className={styles.summaryLabel}>Boards:</h4>
            <Button variant="subtle" onClick={() => setActiveStep(1)}>
              <span className={styles.editButtonText}>Edit</span>
            </Button>
          </div>
          <div className={styles.flexRowSpaceBetween}>
            <span className={styles.summaryValue}>{state.board?.name || ''}</span>
          </div>
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.flexRowSpaceBetween}>
            <h4 className={styles.summaryLabel}>Status Mapping:</h4>
            <Button variant="subtle" onClick={() => setActiveStep(2)}>
              <span className={styles.editButtonText}>Edit</span>
            </Button>
          </div>
          {bloomfilterStatusOptions.map((bloomfilterStatus) => (
            <div key={bloomfilterStatus.name} className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
              <b className={styles.summaryValue}>{bloomfilterStatus.label}</b>
              <div className={styles.flexRowGap}>
                {state.bloomfilterStatuses?.[bloomfilterStatus.name]?.map((statue) => (
                  <span key={statue}>{statue}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.summaryItem}>
          <div className={styles.flexRowSpaceBetween}>
            <h4 className={styles.summaryLabel}>Settings:</h4>
            <Button variant="subtle" onClick={() => setActiveStep(3)}>
              <span className={styles.editButtonText}>Edit</span>
            </Button>
          </div>
          <div className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
            <b>Team Size: </b>
            {state.settings.devTeamSize}
          </div>
          <div className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
            <b>Point Bugs?: </b>
            {state.settings.pointBugs
              ? i18n.t('integrations.settings.point_bugs_yes', {
                  estimation: i18n.t('common.estimation').toLowerCase(),
                })
              : i18n.t('integrations.settings.point_bugs_no')}
          </div>
          <div className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
            <b>Require Labels?: </b>
            {state.settings.requireLabels ? 'Yes, we label cards' : "No, we don't expect cards to be labeled."}
          </div>
          <div className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
            <b>Working Hours Start: </b>
            {convertTo12HourFormat(state.settings.workingHoursStart)}
          </div>
          <div className={`${styles.flexRowSpaceBetween} ${styles.bottomBorder}`}>
            <b>Working Hours End: </b>
            {convertTo12HourFormat(state.settings.workingHoursEnd)}
          </div>
        </div>
      </div>
    </div>
  );
}
